// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'sewing-machine';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.156 1.031a1.062 1.062 0 0 0-1.062 1.063v4.25a1.062 1.062 0 0 0 1.062 1.062h3.719l1.594-1.062H9.53a2.125 2.125 0 0 1 2.125 2.125v3.187a2.125 2.125 0 0 1-2.125 2.125H2.625a1.595 1.595 0 0 0 0 3.188h12.219a2.125 2.125 0 0 0 2.125-2.125V3.156a2.125 2.125 0 0 0-2.125-2.125zm2.125 6.375v4.25m0-1.062h1.594' />
    <path d='M16.969 5.636h-2.834a1.063 1.063 0 0 1 0-2.125h2.834zM5.281 1.031v4.25' />
  </g>
);

export const viewBox = '0 0 18 18';
